import { Component, OnInit, ElementRef } from '@angular/core';
import { ConfigService } from 'src/app/shared/config.service';
import { FormDataService } from 'src/app/shared/form-data.service';

@Component({
  selector: 'app-response',
  templateUrl: './response.component.html',
  styleUrls: ['./response.component.scss']
})
export class ResponseComponent implements OnInit {
  contentDetail: any;
  isEasyClaimTlAcceptType: boolean;
  isEcInternalJourney: boolean;
  ecInternalJourneyCepUrl: string;
  engineeringOutcome: string;
  constructor(
    private configService: ConfigService,
    private el: ElementRef,
    private formDataService: FormDataService,
  ) { 
    this.contentDetail = this.configService.config.Data.contentDetail;
    this.isEasyClaimTlAcceptType = this.formDataService.getIsEasyClaimTlAcceptType();
    var ecInternalJourney = this.configService.config.Data.EcInternalJourney;
    var orgUrlCode = this.configService.config.Data.OrgUrlCode;
    if(ecInternalJourney == "yes")
    {
      this.isEcInternalJourney = true;
    }
    else
    {
      this.isEcInternalJourney = false;
    }

    this.ecInternalJourneyCepUrl = this.formDataService.ecInternalJourneyUrl + orgUrlCode;
    this.engineeringOutcome = this.formDataService.getEngineeringOutcome();    
  }

  ngOnInit() {
    var photoEl = this.el.nativeElement.parentElement.parentElement.childNodes[0].childNodes[0];
    if(photoEl != null)
    {
      photoEl.classList.add("disableCls");
    }    
  }

  redirectToCep() {
    
    window.location.href = this.ecInternalJourneyCepUrl;
  }

}
